import React from 'react'
import HeadData from 'components/Common/HeadData'

import Travel from './Travel/Travel'
import OurStory from './OurStory/OurStory'
import WorkWithUs from './WorkWithUs/WorkWithUs'
import config from 'constants/config'
import ImageHero from 'components/Common/ImageHero'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'components/Luxkit/Typography/Heading'
import Subtitle from 'components/Luxkit/Typography/Subtitle'
import { rem } from 'polished'
import styled from 'styled-components'
import WhyBookWithUsSection from './WhyBookWithUs/WhyBookWithUsSection'
import Reviews from 'components/Pages/AboutUsPage/Reviews/Reviews'
import PartnerBrands from 'components/Common/PartnerBrands/PartnerBrands'

const HeroImage = styled(ImageHero)`
  max-height: ${rem(470)};
`

function AboutUsPage() {
  const showPartnerLogos = config.logoImages && config.logoImages.length > 0
  return (
    <>
      <HeadData
        title={`About Us - ${config.title}`}
        description="Information about the company, Leadership and culture"
      />
      <HeroImage
        alt="About us header image"
        id="about-us-image"
      >
        <LayoutContainer>
          <Heading variant="heading2" align="center" colour="neutral-eight">
            The world’s best escapes, handpicked by experts
          </Heading>
          <Subtitle variant="subtitle1" align="center" colour="neutral-eight">
            At Luxury Escapes we believe everyone should travel in style. That’s why we offer the world’s{' '}
            most amazing travel experiences at great prices.
          </Subtitle>
        </LayoutContainer>
      </HeroImage>
      <OurStory />
      <WhyBookWithUsSection />
      <Travel />
      <Reviews />
      {showPartnerLogos && <PartnerBrands />}
      <WorkWithUs />
    </>
  )
}

export default AboutUsPage
